import BN from 'bignumber.js';

export const getDuration = (time) => {
  if (!time || time === '0') {
    return '0';
  }

  return new BN(Date.now()).div(1000).minus(time).div(60).div(60).div(24).toFixed(0);
};
